module.exports = __webpack_public_path__ + "static/media/black_background_01.3a594ad7.jpg";